import {
  HttpRequest,
  HttpEvent,
  HttpHandlerFn,
  HttpEventType
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import _ from 'lodash';
import { environment } from '../../environments/environment';

export function ErrorHandlerInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  return next(req).pipe(tap(res => {
    // StreamableFile always returns x-krakend-completed equal to false,
    // that's why we need some exceptions for this error handler check
    const krakendExceptionsGet = [
      environment.api_endpoints.file,
      '/document/pdf',
      '/document/xml',
      '/document/',
      '/avatar',
      '/my-document/',
      '/pdf-sample/',
    ];
    if (res.type === HttpEventType.Response && 
      !(req.method === 'GET' && _.some(krakendExceptionsGet, (e) => _.includes(req.url, e)))) {
      const krakendCompleted = _.get(res, 'headers')?.get('x-krakend-completed');
      if (krakendCompleted === "false") {
        let err = {};
        for (let n = 0; n < 5; n++) {
          if (_.get(res, 'body.error_' + n)) {
            _.set(err, 'message', JSON.parse(_.get(res, 'body.error_' + n + '.http_body')));
            throw err;
          }
        }
        throw res;
      }
    }
  }));
}
